<template>
  <div class="tab">
    <h3>CPYDS项目团队</h3>
    <div>
      <p>北京师范大学林丹华教授为CPYDS项目的首席专家，带领此项目团队开展了相关系列研究。该项目组成员来自河南、辽宁、湖南、江西、贵州、北京、上海、陕西、浙江和广东等地区的国内各大高校研究团队，还汇集了心理学、社会学、教育学、公共卫生等多学科的国内外专家学者。同时，相关领域的博士和硕士研究生也共同参与了项目的设计、具体研究和调查实施等工作。  </p>
      <div class="team">
        <div><img src="../../assets/8.png" alt=""><span>北京师范大学</span></div>
        <div><img src="../../assets/3.png" alt=""><span>河南大学</span></div>
        <div><img src="../../assets/1.png" alt=""><span>辽宁师范大学</span></div>
        <div><img src="../../assets/4.png" alt=""><span>湖南师范大学</span></div>
        <br>
        <div><img src="../../assets/6.png" alt=""><span>江西师范大学</span></div>
        <div><img src="../../assets/5.png" alt=""><span>复旦大学</span></div>
        <div><img src="../../assets/2.png" alt=""><span>陕西师范大学</span></div> 
        <div><img src="../../assets/7.png" alt=""><span>浙江师范大学</span></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'team',
  data () {
    return {}
  }
}
</script>
<style scoped src="../../assets/style/grandchild.css">
  /* @import '../assets/style/child.css'; */
</style>



// WEBPACK FOOTER //
// src/components/tabs/team.vue